import bulkMigratePriceList from '@/api/post/company/company-price/bulk-migrate-price-list';
import FormWrapper from '@/components/form-wrapper/form-wrapper-component';
import { Row } from '@/components/grid/grid-component';
import Loader from '@/components/loader/loader-component';
import { useMutation } from '@/hooks/use-api';
import PropTypes from 'prop-types';
import ReactDOMServer from 'react-dom/server';
import Swal from 'sweetalert2';
import MigratePricingModal from './migrate-pricing-modal';
import './swal.css';

const swalDivStyle = {
  display: 'flex',
  justifyContent: 'flex-start',
  width: '90%',
  flexDirection: 'column',
};

const rowStyle = {
  marginLeft: '0px',
  marginRight: '0px',
  marginBottom: '40px',
  marginTop: '0px',
};

/**
 * Create a pricing wrapper
 * @param {object} root0 - props
 * @param {Function} root0.onClose - Function to set the open state of the create modal
 * @param {string} root0.companyId - companyId passed either selectedSupplier or Company;
 * @param {Function} root0.refetch - Function to refetch the table data
 * @returns {JSX.Element}
 */
const MigratePricingWrapper = ({ companyId, onClose, refetch }) => {
  const [migrateBulkPriceList, { loading: loadingImportCompany }] =
    useMutation(bulkMigratePriceList);

  const submitForm = (values) => {
    migrateBulkPriceList(values, companyId).then((res) => {
      onClose(false);
      Swal.fire({
        title: 'Bulk import Results',
        html: ReactDOMServer.renderToString(
          <div style={swalDivStyle}>
            <ul>
              <li>{res.data.updated} components have been migrated.</li>
            </ul>
          </div>,
        ),
        showCloseButton: true,
        confirmButtonText: 'ok',
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.isConfirmed) {
          refetch();
        }
      });
    });
  };

  return (
    <FormWrapper>
      {loadingImportCompany ? (
        <Row style={rowStyle} justify="center">
          <Loader loading loadingText="...Loading" />
        </Row>
      ) : (
        <MigratePricingModal companyId={companyId} onSubmit={submitForm} />
      )}
    </FormWrapper>
  );
};

MigratePricingWrapper.defaultProps = {
  onClose: () => {},
  refetch: () => {},
  companyId: '',
};

MigratePricingWrapper.propTypes = {
  onClose: PropTypes.func,
  refetch: PropTypes.func,
  companyId: PropTypes.string,
};
export default MigratePricingWrapper;
